var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.667,
    fill: "#000",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.417,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.292 3.995a42.587 42.587 0 01-.417.86l-.266.525c-.09.184-.184.37-.281.557-.094.188-.186.367-.276.537l-.24.463a8.9 8.9 0 01-.182.334.79.79 0 01.339-.104 3 3 0 01.442-.01 1.662 1.662 0 011.089.411c.128.114.234.243.318.385a2.153 2.153 0 01.333 1.057v.302c0 .066-.002.134-.005.203 0 .07-.002.129-.006.178a5.086 5.086 0 01-.036.192 2.74 2.74 0 01-.318.818c-.093.16-.217.313-.37.458a2.193 2.193 0 01-.557.37c-.218.104-.479.168-.781.193a2.314 2.314 0 01-.838-.063 1.913 1.913 0 01-1.073-.74 2.54 2.54 0 01-.282-.52 2.535 2.535 0 01-.135-.51 1.721 1.721 0 01-.01-.417c.02-.17.043-.321.067-.453.025-.136.052-.264.084-.386.034-.121.072-.241.114-.36.042-.117.09-.246.146-.385a705.331 705.331 0 00.344-.73 96.8 96.8 0 01.312-.629 682.019 682.019 0 011.255-2.536h1.23zm-.22 5.557c0-.132-.004-.278-.015-.438-.01-.16-.05-.31-.12-.453a.908.908 0 00-.328-.375c-.152-.104-.37-.166-.65-.187a.862.862 0 00-.36.041.992.992 0 00-.287.157 1.141 1.141 0 00-.218.229c-.06.083-.11.167-.151.25a1.277 1.277 0 00-.084.234.718.718 0 00-.026.162c0 .087.002.184.005.291.004.105.014.21.032.318.02.104.054.207.099.307a.82.82 0 00.192.26c.084.077.19.14.318.188.132.049.295.073.49.073.156.004.291-.015.406-.057a.966.966 0 00.5-.396 1.22 1.22 0 00.12-.245 1.089 1.089 0 00.078-.36z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgSource6;